/* eslint-disable @typescript-eslint/no-require-imports */
import { FontSource, useFonts as useExpoFonts } from "expo-font";

export const useLoadWebFonts = () => {
  useExpoFonts({
    "RethinkSans-Regular":
      require("../../assets/fonts/RethinkSans-Regular.ttf") as FontSource,
    "RethinkSans-Medium":
      require("../../assets/fonts/RethinkSans-Medium.ttf") as FontSource,
    "RethinkSans-SemiBold":
      require("../../assets/fonts/RethinkSans-SemiBold.ttf") as FontSource,
  });
};
